import React, { useEffect, useState } from "react";
import AuthService from "../../services/AuthService";
import { buildLeadPrintHtml, normalizeAgencyResponse } from "../../utils/printLeadReport";

const PrintLead = ({ leadassigned }) => {
  const [html, setHtml] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadReport() {
      const clientId = AuthService.getLoggedInClientId();
      let agency = {};
      try {
        agency = normalizeAgencyResponse(
          (await AuthService.getAgencyLogoAndNameByClientId(clientId)) || {},
        );
      } catch (error) {
        console.error("Error fetching agency for print:", error);
      }
      if (!cancelled) {
        setHtml(buildLeadPrintHtml(leadassigned, agency));
      }
    }

    if (leadassigned) {
      loadReport();
    }

    return () => {
      cancelled = true;
    };
  }, [leadassigned]);

  useEffect(() => {
    if (html) {
      window.print();
    }
  }, [html]);

  if (!html) return null;

  return (
    <iframe
      title="Lead Report"
      srcDoc={html}
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
};

export default PrintLead;
